function tallyBubble() {
  //console.log('tallybubble');
	$.ajax({
      url: '/cart.js',
      type: 'GET',
      dataType: 'JSON',
      success: function(data) {
          jQuery('#CartBubble').text(data.item_count)
                  //change the checkout button
        AddLock()
      }
  });
}

function AddLock() {
  //console.log('AddLock')
 jQuery('.cart__lock').html('Check Out <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-lock" style="height: 16px; width: 16px; vertical-align: text-top" viewBox="0 0 17 20"><path fill="#FFF" d="M15.725 8.333H15.3V6.875C15.3 3.02 12.313 0 8.5 0 4.687 0 1.7 3.02 1.7 6.875v1.458h-.425C.571 8.333 0 8.893 0 9.583v9.167C0 19.44.571 20 1.275 20h14.45c.704 0 1.275-.56 1.275-1.25V9.583c0-.69-.571-1.25-1.275-1.25zM4.25 6.875C4.25 4.381 6.077 2.5 8.5 2.5s4.25 1.88 4.25 4.375v1.458h-8.5V6.875zm5.95 8.142c0 .91-.754 1.65-1.683 1.65h-.034c-.93 0-1.683-.74-1.683-1.65v-1.7c0-.911.754-1.65 1.683-1.65h.034c.93 0 1.683.739 1.683 1.65v1.7z"/></svg>')
}

function safeImageCleanup() {
  /*don't run if color filter is triggered by looking at the url*/
  if (window.location.href.indexOf("pf_opt_color") > -1) {
    console.log('color picked, skipping safe image')
  } else {
    jQuery('.boost-sd__product-item').each(function() {
      var safeimage = jQuery(this).attr('safeimage')
      if(safeimage != undefined) {
        var safeimagetest = safeimage.split('?')[0]
        //https://cdn.shopify.com/s/files/1/0345/1237/1850/files/2000_2000_317073_sourceimage.jpg?v=1692036407&width=239
        var currentimage = jQuery(this).find('.boost-sd__product-image-img').attr('src')
        var currentimagetest = currentimage.split('?')[0]
        if(safeimage != '' && safeimagetest != currentimagetest) {
          //console.log(safeimagetest)
         // console.log(currentimagetest)
          jQuery(this).find('.boost-sd__product-image-img').attr('src',safeimage).removeAttr('srcset')
          jQuery(this).attr('safeimage','').addClass('safeimageset')
        }
      }
    });
  }
}

function pricingCleanupCollection() {
 
    jQuery('.boost-sd__product-price').each(function() {
      //console.log(jQuery(this))
        if(jQuery(this).hasClass('pricescleanedup')) {
            //already adjusted
        } else if(jQuery(this).find('.discountedprice').length > 0) {
 console.log('pricingCleanupCollection')
            //get prices
            var baseprice = jQuery(this).find('.boost-sd__format-currency--price-compare > span').text()
            var lowestprice = jQuery(this).find('.lowestpriceset').text()
            var discountedprice = jQuery(this).find('.discountedprice').text()
            var variableprice = false
            var newhtml = ''
            if(baseprice == '') { baseprice = lowestprice }

            //if we have 'from', we need to add it to Discounted Price
            var saleprice = jQuery(this).find('.boost-sd__product-price-content > span').text()
            if(saleprice.indexOf('From') > -1) {
            variableprice = true
            }

            if(variableprice == true && discountedprice != '') {
                newhtml = '<span class="setlowestprice_strike">'+baseprice+'</span><span class="setdiscountprice">From '+discountedprice+'</span>'
            } else if(variableprice == false && discountedprice != '') {
                newhtml = '<span class="setlowestprice_strike">'+baseprice+'</span><span class="setdiscountprice">'+discountedprice+'</span>'
            } else if(variableprice == true && discountedprice != '') {
                newhtml = '<span class="setlowestprice_strike">'+baseprice+'</span><span class="setdiscountprice">'+discountedprice+'</span>'
            } else {
                newhtml = '<span class="setlowestprice">'+baseprice+'</span>'
            }

            jQuery(this).before(newhtml)
            jQuery(this).addClass('pricescleanedup').hide()
            //jQuery(this).css('opacity','.6')
            //console.log('baseprice'+baseprice+' variableprice '+variableprice+ ' lowestprice '+lowestprice+' discountedprice '+discountedprice+ 'variableprice '+variableprice)
        }
    })
}

jQuery(function() {
  jQuery('body').on('click','.add-to-cart, .js-qty__adjust',function() {
	//slight delay for other process
  	setTimeout('tallyBubble()',1000)
  });

  /*leaving this - but it runs too often
  jQuery("body").on('DOMSubtreeModified', ".boost-sd-left", function() {
    console.log('on change hit pricingCleanupCollection')
    setTimeout('pricingCleanupCollection()',100)
  });
  */

  //hit this on load, just in case
  pricingCleanupCollection()
  
  AddLock()
  setTimeout('AddLock()',1500);
  setTimeout('AddLock()',2500);

  var elem = document.querySelector('.logo-bar');
  var flkty = new Flickity( elem, {
  // options
  cellAlign: 'center',
  contain: true,
  wrapAround: true,
  initialIndex: 1,
  groupCells: 2
  });
});